import type {
  BanknoteDesign,
  BanknoteInstance,
  BanknoteVisualProps,
  FakeVariantDefinition,
} from '../models/BanknoteTypes';

let instanceCounter = 0;

function createInstanceId(): string {
  instanceCounter += 1;
  return `inst_${Date.now()}_${instanceCounter}_${Math.random().toString(36).slice(2, 8)}`;
}

/**
 * Seri numarası üretir — format: # = rastgele rakam.
 */
export function generateSerial(format: string): string {
  return format.replace(/#/g, () => String(Math.floor(Math.random() * 10)));
}

/**
 * Gerçek ve sahte banknot instance'ları oluşturur.
 */
export class BanknoteInstanceFactory {
  createAuthentic(design: BanknoteDesign): BanknoteInstance {
    return {
      instanceId: createInstanceId(),
      designId: design.id,
      variantId: null,
      isAuthentic: true,
      serial: generateSerial(design.serialFormat),
      denomination: design.denomination,
      brandLabel: design.brandLabel,
      visual: { ...design.visual },
    };
  }

  createFake(
    _authentic: BanknoteInstance,
    design: BanknoteDesign,
    variant: FakeVariantDefinition,
    visual: BanknoteVisualProps,
    serial: string,
  ): BanknoteInstance {
    return {
      instanceId: createInstanceId(),
      designId: design.id,
      variantId: variant.id,
      isAuthentic: false,
      serial,
      denomination: design.denomination,
      brandLabel: design.brandLabel,
      visual,
    };
  }
}
